// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"91a20de7","563":"8f464750"}[chunkId] + ".chunk.js";
};